(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-editorial-list"]) return;
  try {
    

  document
    .querySelectorAll('.editorial-item')
    .forEach(function(item) {

      var mainImg =
        item.querySelector('.editorial-image-wrap img');

      var swatches =
        item.querySelectorAll('.editorial-swatch');

      if (!mainImg || swatches.length === 0) return;

      var originalSrc =
        mainImg.getAttribute('src');

      swatches.forEach(function(swatch) {

        var newImg =
          swatch.getAttribute('data-image');

        if (!newImg) return;

        swatch.addEventListener(
          'mouseenter',
          function() {

            mainImg.setAttribute(
              'src',
              newImg
            );

          }
        );

      });

      item.addEventListener(
        'mouseleave',
        function() {

          mainImg.setAttribute(
            'src',
            originalSrc
          );

        }
      );

    });


  document
    .querySelectorAll('.editorial-add-btn')
    .forEach(function(btn) {

      btn.addEventListener(
        'click',
        function(e) {

          e.preventDefault();
          e.stopPropagation();

          var variantId =
            btn.getAttribute('data-variant-id');

          if (!variantId) return;

          var originalText =
            btn.textContent;

          btn.disabled = true;
          btn.textContent = 'Ajout...';

          fetch('/cart/add.js', {

            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },

            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })

          })

          .then(function(res) {

            if (!res.ok) {
              throw new Error('Erreur');
            }

            return res.json();

          })

          .then(function() {

            btn.textContent = '✓ Ajouté';

            document.dispatchEvent(
              new CustomEvent('cart:refresh')
            );

            setTimeout(function() {

              btn.textContent =
                originalText;

              btn.disabled = false;

            }, 1800);

          })

          .catch(function() {

            btn.textContent = 'Erreur';

            setTimeout(function() {

              btn.textContent =
                originalText;

              btn.disabled = false;

            }, 1800);

          });

        }
      );

    });


  } catch(e) { console.error(e); }
})();
})();
